<template>
    <div class="master-section appointment-layout section_1">
        <section class="row align-items-center">
            <div class="col-12 mx-auto">
                <div class="master-template__form">
                    <h2 class="master-template__form-title" v-if="title_form"> {{ title_form }}</h2>
                    <div class="master-template__form-descirption" v-if="description" v-html ="description"></div>
                    <form @submit.prevent="submitForm" class="altform master-template__form-fields" id="form-consulation" @click="startLoadRecaptcha">
                        <div id="name-form-group" class=" alt-form-group email-form-group form-group">
                            <FormInput
                                v-model="form.name"
                                required
                                @clearError="clearFieldError('name')"
                                label="Name"
                                :placeholder="name_ph"
                                :rules="[
                                    { required: 'Please enter your First name' },
                                    { pattern: { value: /^[A-Za-z ]+$/, message: 'First Name cannot contain numbers' } },
                                    { maxLength: { value: 50, message: 'First Name cannot exceed 50 characters' } }
                                ]"
                                :errorMessage="errors.name"
                            />
                        </div>
                        <div id="email-form-group" class=" alt-form-group email-form-group form-group">
                            <FormInput
                                v-model="form.email"
                                @clearError="clearFieldError('email')"
                                required
                                :placeholder="email_ph"
                                label="Email"
                                type="text"
                                :rules="[
                                    { required: 'Please enter your Email' }, 
                                    { maxLength: 50, message: 'Email cannot be longer than 50 characters' },
                                    { isEmail: true, message: 'Please enter a valid email address' }
                                ]"
                                :errorMessage="errors.email"
                            />
                        </div>
                        <div id="phone-form-group" class="alt-form-group text-form-group form-group">
                            <FormInput
                                v-model="form.phone"
                                label="Contact Number"
                                required
                                @clearError="clearFieldError('phone')"
                                :placeholder="phone_ph"
                                :rules="[
                                    { required: 'Please enter your Contact number' },
                                    { pattern: { value: /^[0-9]+$/, message: 'Contact Number cannot contain alphabets' } },
                                    { minLength: 8, message: 'Length is 8-15 characters.' },
                                    { maxLength: 15, message: 'Length is 8-15 characters.' }
                                ]"
                                :errorMessage="errors.phone"
                            />
                        </div>
                        <FormSelect
                            v-model="form.type_consolution"
                            @clearError="clearFieldError('type')"
                            :options="option_type"
                            required
                            :label="type_label"
                            placeholder="Select"
                            :rules="[{ required: 'Please select a type' }]"
                            :errorMessage="errors.type_consolution"
                        />
                        <FormSelect
                            v-if="form.type_consolution"
                            v-model="form.store"
                            @clearError="clearFieldError('store')"
                            :options="option_store"
                            :label="store_label"
                            placeholder="Select Store"
                            :rules="[{ required: 'Please select a store' }]"
                            :errorMessage="errors.store"
                        />
                       
                        <div class="row" id="datetime-form-group">
                            <div class="col-md-6">
                                <FormInput
                                    v-model="form.date_consulation"
                                    @clearError="clearFieldError('date_consulation')"
                                    label="Preferred Date"
                                    required
                                    :offsetDays=2
                                    placeholder="Date"
                                    type="date"
                                    :minDate="true"
                                    :disabled-dates="blockedDates"
                                    :rules="[
                                        { type: 'required', message: 'Please select a date' },
                                        { type: 'workdayOnly' },
                                        { type: 'futureOnly' }
                                    ]"
                                    :errorMessage="errors.date_consulation"
                                    />
                            </div>
                            <div class="col-md-6">
                                <FormSelect
                                    v-model="form.time_consulation"
                                    required
                                    @clearError="clearFieldError('time_consulation')"
                                    :options="timeOptions"
                                    :label="time_label"
                                    :errorMessage="errors.time_consulation"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <FormInput
                                    v-model="form.massage"
                                    @clearError="clearFieldError('massage')"
                                    label="message"
                                    placeholder="Include any special request, or query that you may have regarding your ear piercings!"
                                    type="textarea"
                                    :errorMessage="errors.massage"
                                    />
                            </div>
                        </div>
                        <div id="alt-recaptcha">
                            <Recaptcha ref="recaptchaRef" v-if="siteKey_recapcha" v-model="form.recaptcha" :siteKey="siteKey_recapcha" />

                        </div>
                        <div id="item_marketing_consent-form-group" class="alt-form-group checkbox-form-group form-group">
                            <FormCheckbox
                                v-model="form.item_marketing_consent"
                                @clearError="clearFieldError('item_marketing_consent')"
                                label="I agree to receive marketing communications from SK Jewellery"
                                id="item_marketing_consent"
                                :rules="[{ required: 'This field is required' }]"
                                :errorMessage="errors.item_marketing_consent"
                            />
                        </div>
                        <!-- Submit Button -->
                        <div class="altform-submit-group">
                            <button :disabled="isSubmitting" type="submit" class="btn button-submit">
                                <span class="button__text">
                                    Request a Consultation Slot
                                </span>
                            </button>
                            <div v-if="isSubmitting" class="loading"> </div>
                        </div>
                        <p v-if="responseMessage" class="altform-message" :class="{'success-message': isSuccess, 'text-danger': !isSuccess }">
                        {{ responseMessage }}
                        </p>
                    </form>
                </div>
            </div>
        </section>
    </div>
</template>
<script lang="ts" setup>
    import FormSelect from "~/components/Career/Forms/FormSelect.vue";
    import FormInput from "~/components/Career/Forms/FormInput.vue";
    import FormCheckbox from "~/components/Career/Forms/FormCheckbox.vue";
    import Recaptcha from '~/components/Career/Forms/Recaptcha.vue';
    const { pushToDataLayer, pushPageTypeToDataLayer } = useCustomGtm();
    import { useInsiderSdk } from '~/composables/insiderSdk'
    const { $ajax } = useNuxtApp();
    const router = useRouter(); 
    const route = useRoute(); 
    const props = defineProps({
        data_title: String,
        data_description: String,
        data_key: String,
        data_postId: Number,
        data_store: Array,
        data_type: Array,
        data_page_title: String,
        data_store_label: String,
        data_type_label: String,
        data_time_label: String,
        data_name_ph: String,
        data_email_ph: String,
        data_phone_ph: String
    });

    const isSubmitting = ref(false);
    const responseMessage = ref('');
    const isSuccess = ref(false);
    const recaptchaRef = ref(null);
    const siteKey_recapcha = ref<string | undefined>(undefined)
    // const siteKey = ref(props.data_key);
    const formClicked = ref(false);
    const userStore = useUserStore();

    const page_title = computed(() => props.data_page_title);
    const store_label = computed(() => props.data_store_label || 'Select Store');
    const type_label = computed(() => props.data_type_label || 'Type of consultation');
    const time_label = computed(() => props.data_time_label || 'Preferred Time');
    const name_ph = computed(() => props.data_name_ph || 'Enter your name');
    const email_ph = computed(() => props.data_email_ph || 'Enter your email');
    const phone_ph = computed(() => props.data_phone_ph || 'Enter your number');
    const title_form = computed(() => props.data_title);
    const description = computed(() => props.data_description);
    // siteKey_recapcha = computed(() => props.data_key);
    const post_id_form = computed(() => props.data_postId);
    const option_store = computed(() => props.data_store);
    // const option_type = computed(() => props.data_type);
    import { useI18n } from 'vue-i18n';
    const { locale } = useI18n();
    let country = '';
    if (locale.value === 'ms-my') {
        country = '/ms-my';
    } else {
        country = '';
    }
    const option_type = ref<{ value: string; label: string }[]>([
        { value: 'In-Store Consultation', label: 'In-Store Consultation' },
    ])
    const clearDatePicker = () => {
        nextTick(() => {
            // Type assertion to HTMLElement to access `click` method
            const clearBtn = document.querySelector('.dp--clear-btn') as HTMLElement;
            if (clearBtn) {
                clearBtn.click();
            } else {
                console.warn("Clear button not found.");
            }
        });
    };
    watch(
        () => props.data_key,
        (newKey) => {
            if (newKey) {
                setTimeout(() => {
                    siteKey_recapcha.value = newKey; // Set siteKey after 1s delay
                }, 200); // 1-second delay

            }
        },
        { immediate: true }
    );
    const blockedDates = computed(() => {
        const today = new Date();
        const currentMonth = today.getMonth();
        const currentYear = today.getFullYear();
        // Only block dates 14-18 in February 2026
        if (currentMonth === 1 && currentYear === 2026) {
            return [
                new Date(2026, 1, 14),
                new Date(2026, 1, 15),
                new Date(2026, 1, 16),
                new Date(2026, 1, 17),
                new Date(2026, 1, 18)
            ];
        }
        return [];
    });
    const startLoadRecaptcha = () => {
        if (recaptchaRef.value){
            if(!formClicked.value){
                // loadRecaptchaScript(); // Call the function to load reCAPTCHA script
                recaptchaRef.value.loadRecaptchaScript();
                // Add a delay before attempting to retrieve the token
                setTimeout(async () => {
                    try {
                    const token = await recaptchaRef.value.getToken();
                    // Optionally store or use the token
                    } catch (error) {
                    console.error('Error fetching reCAPTCHA token:', error);
                    }
                }, 500);
            }
        }
        formClicked.value = true
    }
    
    const submitForm = async () => {
        responseMessage.value = '';
        if (isSubmitting.value) return;
        
        const isValid = validateForm();
        if (!isValid) {
            responseMessage.value = 'Please enter all required fields'
            return;
        }
        if (recaptchaRef.value){
            recaptchaRef.value.getToken();
        }

        if (!form.value.recaptcha) {
            return;
        }

        try {
            isSubmitting.value = true; 
            // Create FormData object
            const formData = new FormData();

            // Append all form fields to FormData object
            for (const key in form.value) {
                const value = form.value[key as keyof FormState];
                formData.append(key, String(value));
               
            }

            // for (const [key, value] of formData.entries()) {
            // }

            // const response = await $ajax.post<any>('/wp-json/api-forms/submit_kform', formData, {
            //      headers: {"Authorization": `Bearer ${userStore.csrf}`} 
            // }); 

            const response = await $ajax.post<any>('wp-json/skj/v1/submit_kform', formData, {
                headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${userStore.csrf}`
                }
            });
            if(response.success||response.error==false) {
            // insider sdk
                 console.log('tracking insider skd');
                 const {
                    trackInsiderSdkEvent
                } = useInsiderSdk();
                 trackInsiderSdkEvent(
                    'insider_sdk_booking_appointment',
                    '',
                    '',
                )
                // end inside sdk
                pushToDataLayer('book_appointment');
                isSuccess.value = true;
                responseMessage.value = response.message || 'Thank for contacting us! We will get in touch with you shortly';
                form.value.store = '';
                form.value.date_consulation = '';
                form.value.time_consulation = '';
                form.value.name = '';
                form.value.phone = '';
                form.value.email = '';
                form.value.massage = '';
                form.value.item_marketing_consent = false;
                clearDatePicker();
                if (response.result && response.result.settings && response.result.settings.redirect_url) {
                    router.push(`${country}/thank-you-for-booking-an-appointment-with-us`);
                    // window.location.href = response.result.settings.redirect_url;
                }
            }
        } catch (error) {
            isSuccess.value = false;
            // Check if error is due to reCAPTCHA failure
            if (error.data?.message === 'reCAPTCHA verification failed' && recaptchaRef.value) {
                // Get a new token
                recaptchaRef.value.getToken();
                 setTimeout(async () => {
                    submitForm();
                 }, 1000);
                return;
            }
            responseMessage.value = error.message || error.data?.message || 'An error occurred. Please try again.';
        }finally {
            isSubmitting.value = false;
        }

    };

    const validateForm = () => {
        let isValid = true;
        for (const key in errors.value) {
            errors.value[key] = null;
        }
        if (!form.value.store || form.value.store=='') {
            errors.value.store = 'Please select a store';
            isValid = false;
        }

        if (!form.value.name) {
            errors.value.name = 'Please enter your Name';
            isValid = false;
        } else if (!/^[A-Za-z ]+$/.test(form.value.name)) {
            errors.value.name = 'First Name cannot contain numbers';  
            isValid = false;
        }

        if (!form.value.phone) {
            errors.value.phone = 'Please enter your Contact number';
            isValid = false;
        } else if (!/^[0-9]+$/.test(form.value.phone)) {
            errors.value.phone = 'Contact Number cannot contain alphabets';
            isValid = false;
        } else if (form.value.phone.length < 9 || form.value.phone.length > 11) {
            errors.value.phone = 'Please enter a mobile number with 9 to 11 digits.';
            isValid = false;
        } 
        // else if (form.value.phone.length > 15) {
        //     errors.value.phone = 'Please enter an 8 digit mobile number.';
        //     isValid = false;
        // }

        if (!form.value.email) {
            errors.value.email = 'Please enter your Email';
            isValid = false;
        } else if (!/^\S+@\S+\.\S+$/.test(form.value.email)) {
            errors.value.email = 'Please enter a valid email address';
            isValid = false;
        } else if (form.value.email.length > 50) {
            errors.value.email = 'Email cannot exceed 50 characters';
        }
        
        if (!form.value.type_consolution) {
            errors.value.type_consolution = 'The field is required';
            isValid = false;
        }
        if (!form.value.date_consulation || form.value.date_consulation=='NaN/NaN/NaN') {
            // errors.value.date_consulation = 'Please select a date';
            errors.value.date_consulation = 'Date incorrect';
            isValid = false;
        }
        if (!form.value.time_consulation) {
            errors.value.time_consulation = 'Please select time';
            isValid = false;
        }
        
        // if (form.value.agree_terms===false) {
        //     errors.value.agree_terms = 'This field is required';
        //     isValid = false;
        // }

        return isValid;
    };

    interface FormState {
        post_id : any;
        form_id: string;
        type_consolution: string;
        store: string;
        date_consulation: string;
        time_consulation: string;
        page_consulation: any;
        name: string;
        phone: string;
        email: string;
        massage: string;
        url_utm: string;
        item_marketing_consent: boolean;
        recaptcha: string;
    }

    onMounted(() => {
        // siteKey.value = siteKey_recapcha;
        // setTimeout(() => {
        //     if (recaptchaRef.value){
        //         recaptchaRef.value.getToken();
        //     }
        // }, 1000);

        const utmSource = route.query.utm_source as string || '';
        const utmMedium = route.query.utm_medium as string || '';
        const utmCampaign = route.query.utm_campaign as string || '';
        const gclid = route.query.gclid as string || '';
        const utmPage = route.query.utm_page as string || '';

        // Concatenate only if at least one UTM parameter is present
        form.value.url_utm = [utmSource, utmMedium, utmCampaign, gclid, utmPage].some(param => param)
        ? `utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}&gclid=${gclid}&utm_page=${utmPage}`
        : '';
    });


    const form = ref<FormState>({
        post_id : post_id_form,
        form_id: 'consultation',
        type_consolution : '',
        store: '',
        date_consulation: '',
        time_consulation: '',
        page_consulation : page_title ,
        name: '',
        phone: '',
        email: '',
        massage: '',
        url_utm:'',
        item_marketing_consent: false,
        recaptcha: '',
    });

    const errors = ref<{ [key: string]: string | null }>({
        type: null,
        store: null,
        name: null,
        date_consulation: null,
        time_consulation : null,
        email: null,
        phone: null,
        period: null,
        item_marketing_consent: null,
    });

    const clearFieldError = (field: string) => {
        errors.value[field] = null;
    };

    const timeOptions = ref<{ value: string; label: string }[]>([
        { value: '11:00 AM', label: '11:00 AM' },
        { value: '11:30 AM', label: '11:30 AM' },
        { value: '12:00 PM', label: '12:00 PM' },
        { value: '12:30 PM', label: '12:30 PM' },
        { value: '1:00 PM', label: '1:00 PM' },
        { value: '1:30 PM', label: '1:30 PM' },
        { value: '2:00 PM', label: '2:00 PM' },
        { value: '2:30 PM', label: '2:30 PM' },
        { value: '3:00 PM', label: '3:00 PM' },
        { value: '3:30 PM', label: '3:30 PM' },
        { value: '4:00 PM', label: '4:00 PM' },
        { value: '4:30 PM', label: '4:30 PM' },
        { value: '5:00 PM', label: '5:00 PM' },
        { value: '5:30 PM', label: '5:30 PM' },
        { value: '6:00 PM', label: '6:00 PM' },
        { value: '6:30 PM', label: '6:30 PM' },
        { value: '7:00 PM', label: '7:00 PM' },
        { value: '7:30 PM', label: '7:30 PM' },
        { value: '8:00 PM', label: '8:00 PM' }
        
    ]);

</script>
<style lang="scss" >
    @import "@/assets/scss/components/career/_joblist.scss";
    @import "@/assets/scss/components/career/_kforms.scss";
    @import '@/assets/scss/components/master-template/_form.scss';
    input.dp__input{
        padding-inline-start: 0;
    }
    .dp__menu.dp__menu_index{
        border-radius: 10px;
    }
    .dp__active_date{
        background-color: #AD073D !important;
        color: #fff !important;
        border: none;
    }
    .dp__calendar_header{
        font-weight: 400
    }
    .dp__calendar_row{
        margin-top: 0;
        margin-bottom: 0;
    }
    .dp__menu_inner{
        box-shadow: 0px 3px 10px 0 #D4CFD0;
        border-radius: 10px;
    }
    .dp__input_icon{
        right: 2px;
        left: auto;
    }
</style>